<template>
  <div class="manage-tracks">
    <template v-if="trackingNumbers.length">
      <ul class="nav flex-column">
        <li v-for="track in trackingNumbers" :key="track.track_number">
          <a v-show="track.tracking_link" class="bcm-link bcm-link-none" :href="track.tracking_link" target="_blank">
            <svg class="o-icon"><use xlink:href="#link"></use></svg>
          </a>
        </li>
      </ul>
    </template>
    <span v-else class="text">{{$t('not-specified')}}</span>
  </div>
</template>

<script>
// GET ALL TRAKING INFO FROM shippingInformation
import Config from 'config'

export default {
  props: {
    shippingInformation: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    trackingNumbers () {
      const getTrackingNumber = (track) => {
        switch (track.title) {
          case 'TWS':
            return Config.trackOrderCarrierLink.TWS.replace('{{letteraVettura}}', track.track_number)
          case 'UPS':
            return Config.trackOrderCarrierLink.UPS.replace('{{trackNumber}}', track.track_number)
          case 'SDA':
            return Config.trackOrderCarrierLink.SDA.replace('{{trackNumber}}', track.track_number)
          default:
            return false
        }
      }
      if (this.shippingInformation && this.shippingInformation.tracks && this.shippingInformation.tracks.length) {
        return this.shippingInformation.tracks.map((item) => {
          if (getTrackingNumber(item)) {
            return {
              tracking_link: getTrackingNumber(item),
              ...item
            }
          } else {
            return []
          }
        }).flat()
      } else {
        return []
      }
    }
  }
}
</script>
